import { useRouterHelper } from '@shared/core';
import { PlanningRoutes } from '../Planning.routes';
import { useMemo } from 'react';

export function usePlanningRoutes() {
  const { buildPath } = useRouterHelper();
  const hotelBlockPath = useMemo(() => buildPath(PlanningRoutes.hotelblock), [buildPath]);
  return { hotelBlockPath };
}
